export default {
  downloadType: {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    CHROME_EXTENSION: 'chrome-extension',
  },
};
